<template>
  <div class="management-form" style="width: 60%">
    <div class="input-field-container medium">
      <div class="input-field-container-bad-label">
        <label class="required" for="code">{{ $tc("Code", 1) }} *</label>
        <p v-if="checkCode">Limit is: 32</p>
      </div>
      <input
        v-model="listValueData.code"
        id="code"
        class="input-field"
        type="text"
        maxlength="32"
        :disabled="type === 'edit'"
        @keypress="checkAlphanumeric($event)"
      />
    </div>

    <div v-if="!isCustomList" class="input-field-container medium">
      <label for="client_code">
        {{ $t("ClientCode") }}
      </label>
      <input
        v-model="listValueData.client_code"
        id="client_code"
        maxlength="3"
        class="input-field"
      />
    </div>

    <div class="input-field-container medium">
      <div class="input-field-container-bad-label">
        <label class="required" for="Label">{{ $tc("Label", 1) }} *</label>
        <p v-if="checkLabel">Limit is: 255</p>
      </div>
      <input
        v-model="listValueData.libelle"
        id="label"
        class="input-field"
        :disabled="type === 'edit' && !isSuperAdmin"
        maxlength="255"
      />
    </div>

    <div v-if="!isCustomList" class="input-field-container medium">
      <label for="client_label">
        {{ $t("ClientLabel") }}
      </label>
      <input
        v-model="listValueData.client_label"
        id="client_label"
        class="input-field"
      />
    </div>

    <div v-if="!isCustomList" class="input-field-container">
      <label for="definition">{{ $t("Definition") }}</label>
      <input
        v-model="listValueData.definition"
        id="definition"
        class="input-field"
      />
    </div>

    <div class="input-field-container medium">
      <label for="index">
        {{ $t("Index") }}
      </label>
      <input
        v-model="listValueData.index"
        id="index"
        class="input-field"
        type="number"
        min="0"
        @keypress="checkInteger($event)"
      />
    </div>

    <div class="input-field-container medium" />

    <div
      v-if="!isCustomList"
      class="input-field-container medium radio-container"
    >
      <label for="status">
        {{ $t("Blocked") }}
      </label>
      <v-radio-group
        id="status"
        v-model="listValueData.blocked"
        :mandatory="true"
        :row="true"
        :disabled="!isSuperAdmin"
      >
        <v-radio
          :label="$t('Yes')"
          :value="true"
          :ripple="false"
          color="accent"
        />
        <v-radio
          :label="$t('No')"
          :value="false"
          :ripple="false"
          color="accent"
        />
      </v-radio-group>
    </div>

    <div
      v-if="!isCustomList"
      class="input-field-container medium radio-container"
    >
      <label for="deleted">
        {{ $t("Hidden") }}
      </label>
      <v-radio-group
        id="deleted"
        v-model="listValueData.deleted"
        :disabled="!isSuperAdmin && !isAdmin"
        mandatory
        row
      >
        <v-radio
          :label="$t('Yes')"
          :value="true"
          :ripple="false"
          color="accent"
        />
        <v-radio
          :label="$t('No')"
          :value="false"
          :ripple="false"
          color="accent"
        />
      </v-radio-group>
    </div>
  </div>
</template>

<script>
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";

export default {
  name: "ListItemForm",

  mixins: [checkPermissionsMixin],

  props: {
    /**
     * Info of the list item
     */
    listValueData: {
      type: Object
    },

    /**
     * Action type, can be 'edit' or 'create'
     */
    type: {
      type: String
    },

    /**
     * Maximum length of the code field
     */
    characterMaximumLength: {
      type: Number
    },

    /**
     * Input type for the code field
     */
    inputType: {
      type: String
    }
  },

  data() {
    return {
      /**
       * Indicates if the list item belongs to a custom list
       */
      isCustomList: null
    };
  },
  computed:{
    checkCode(){
      return this.checkLimit(this.listValueData.code,32);
    },
    checkLabel(){
      return this.checkLimit(this.listValueData.libelle,255);
    }
  },
  /**
   * Gets the parameter isCustomList from the route and assigns it to the attribute isCustomList
   */
  mounted() {
    this.isCustomList = this.$route.params.isCustomList;
  }
};
</script>
<style>
.input-field-container-bad-label{
  display: flex;
}
.input-field-container-bad-label p{
  margin: 0;
  color: red;
  padding-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/SystemManagement/SystemSettings/ListsSettings/ListItemForm.vue